import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SpeedUnits } from '../../models/speed-units';
import { UserPreferencesService } from '../../services/user-preferences.service';
import { UnitsSettings } from '../../models/unitsSettings';
import { LengthUnits } from '../../models/length-units';
import { EventBroadcastService } from '../../services/event-broadcast.service';
import { UserPreferences } from '../../models/user-preferences';
import { NgbActiveModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { HelpText } from '../../types/help-text';

@Component({
  selector: 'app-tire-size-calculator',
  standalone: true,
  imports: [FormsModule, NgbPopover],
  templateUrl: './tire-size-calculator.component.html',
  styleUrl: './tire-size-calculator.component.scss'
})
export class TireSizeCalculatorComponent {
  @Output() okEvent = new EventEmitter<number>()

  topSpeed?: number;
  engineRPM?: number;
  topGearRatio?: number;
  finalGearRatio?: number;
  tireSize?: number;
  userPreferences: UserPreferences;
  helpText: HelpText = {
    topSpeed: { title: 'Top Speed', text: 'Enter the cars top speed in the second to last gear. This can be found in the gear settings menu.' },
    engineRPM: { title: 'Engine RPM', text: 'Enter the RPM as showin in the gear settings menu.' },
    finalGearRatio: { title: 'Final Gear Ratio', text: 'Enter the final gear ratio as show in the gear settings menu.' },
    topGearRatio: { title: 'Top Gear Ratio', text: 'Enter the gear ratio of the second to last gear in the gear settings menu.'}
  };

  constructor(private userPreferencesService: UserPreferencesService, private eventBroadcastService: EventBroadcastService, private activeModal: NgbActiveModal) {
    this.eventBroadcastService.userPreferencesUpdatedEvent
      .subscribe(() => {
        userPreferencesService.getUserPreferences()
          .subscribe(preferences => this.userPreferences = preferences);

        this.calculateTireSize();
      });
    
    this.userPreferencesService.getUserPreferences()
      .subscribe(preferences => this.userPreferences = preferences);
  }

  calculateTireSize() {
    if (this.topSpeed && this.engineRPM && this.topGearRatio && this.finalGearRatio) {
      let speed = this.topSpeed;
      
      speed = SpeedUnits.speedToMph(this.topSpeed);

      let tireSize = Math.round((((speed * 1.609344 * 1000) / ((this.engineRPM / this.topGearRatio / this.finalGearRatio) * 60) / Math.PI) * 39.37) * 100) / 100;

      if (this.userPreferences.lengthUnits.display == LengthUnits.mm.display) {
        tireSize = LengthUnits.convertInchesToMm(tireSize);
      }

      this.tireSize = Math.round(tireSize*100)/100;
    }
  }

  reset() {
    this.topSpeed = undefined;
    this.engineRPM = undefined;
    this.topGearRatio = undefined;
    this.finalGearRatio = undefined;
    this.tireSize = undefined;

  }

  ok() {
    this.activeModal.close(this.tireSize);
  }

  close() {
    this.activeModal.dismiss();
  }

}
